import { Contract } from "@edp-components/edp-contract";
import { PendingContract } from "@edp-models/edp-pending-contract.model";
import { PartnerInfo } from "@edp-models/edp-partner-info.model";
import { PaymentReference } from "@edp-models/edp-payment-reference.model";
import { ITotalDiscountsByContract } from "@edp-models/total-discount-contract.model";
import { ContractDetails } from "@edp-components/edp-contract/edp-contract-details.model";
import { ComplementaryInfoContract } from "@edp-models/complementary-info.model";
import { ContractDiscounts, ContractFilter, ContractNewTariffs, ContractTariffsMapping, ContractedService, WallboxService } from "@edp-components/edp-contract/edp-contract.model";
import { ICustomUrl } from "@edp-models/deep-link.model";
import { ICheckUpCard } from "@edp-pages/service-funciona/review-check-up/review-check-up.model";
import { Address } from "@edp-models/postal-code.model";
import { Pack } from "@edp-components/edp-pack";
import { BusinessAgrementStatusAPI } from "@edp-models/business-agrements.model";

export interface IContractState {
    contracts: Contract[];
    selectedContract: {
        data: Contract,
        lastAPIError: Error
    };
    selectedContractDetails: {
        data: ContractDetails,
        lastAPIError: Error
    };
    isSingleContract: boolean;
    totalDiscount: number;
    pendingContracts: PendingContract[];
    partnerInfo: {
        data: PartnerInfo,
        lastAPIError: Error
    };
    paymentReference: PaymentReference;
    paymentReferenceError: Error;
    totalDiscountsByContract: ITotalDiscountsByContract;
    complementaryInfo: ComplementaryInfoContract[];
    filters: ContractFilter[];
    urlToRedirect: ICustomUrl;
    checkUpCards: ICheckUpCard[];
    businessAgrements: any;
    updateBusinessAgrementsStatus: BusinessAgrementStatusAPI;
    addressList: Address[];
    tariffsMapping: ContractTariffsMapping;
    newTariffs: ContractNewTariffs;
    packs: Pack[];
    selectedPack: Pack;
    discounts: ContractDiscounts;
    alerts: any;
    contractedServices: ContractedService[];
    wallboxService: WallboxService;
}

export const initialContractKeepState = {
    contracts: [],
    selectedContract: {
        data: null,
        lastAPIError: null
    },
    totalDiscount: 0,
    isSingleContract: true,
    pendingContracts: null,
    paymentReference: null,
    paymentReferenceError: null,
    totalDiscountsByContract: null,
    complementaryInfo: null,
    urlToRedirect: null,
    filters: [],
    checkUpCards: [],
    businessAgrements: null,
    updateBusinessAgrementsStatus: null,
    addressList: [],
    tariffsMapping: null,
    newTariffs: null,
    packs: null,
    selectedPack: null,
    discounts: null,
    contractedServices: [],
    wallboxService: null,
    alerts: null
};

export const initialContractResetState = {
    selectedContractDetails: {
        data: null,
        lastAPIError: null
    },
    partnerInfo: {
        data: null,
        lastAPIError: null
    },
    paymentReference: null,
    paymentReferenceError: null,
};

export const initialContractState: IContractState = {
    ...initialContractKeepState,
    ...initialContractResetState
};
